<template>
	<div class="TopGuidedDownload">
		<div class="botBtn" @click="DownApp()">
			前往App
		</div>
	</div>
</template>

<script>
export default {
	name: "TopGuidedDownload",
	components: {},
	data () {
		return {}
	},
	mounted () { },
	methods: {
		DownApp () {
			// 加载一个iframe页面方法 原生js
			// let iframe = document.createElement('iframe');
			// iframe.style.display = 'none';
			// iframe.src = "./bf2042tracker_DownApp.html"
			// document.body.appendChild(iframe);


			this.$utils.DownApp()
		}
	},
}
</script>

<style lang="scss" scoped>
.TopGuidedDownload {
	height: 0;
	width: 100%;

	.botBtn {
		position: fixed;
		z-index: 999;
		bottom: 54px;
		left: 50%;
		transform: translateX(-50%);
		width: 94px;
		height: 32px;
		background: #eb413d;
		border-radius: 18px;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fffffd;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.FullScreenMask {
		height: 100vh;
		position: fixed;
		z-index: 9999;
		top: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.40);

		.tipsBox {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			width: 270px;
			height: 136px;
			background: #ffffff;
			border-radius: 12px;

			p {
				margin: 24px auto;
				width: 230px;
				height: 44px;
				font-size: 17px;
				font-family: PingFang SC, PingFang SC-Medium;
				font-weight: 500;
				text-align: center;
				color: #222222;
				line-height: 22px;
			}

			.btnbox {
				display: flex;
				position: absolute;
				bottom: 0;
				height: 48px;
				box-sizing: border-box;
				border-top: #eeeeee 1px solid;

				.qx {
					width: 135px;
					height: 48px;
					line-height: 48px;
					box-sizing: border-box;
					border-right: #eeeeee 1px solid;
					background: rgba(255, 255, 255, 0.00);
					border-radius: 0px 0px 0px 12px;
					font-size: 17px;
					font-family: PingFang SC, PingFang SC-Medium;
					font-weight: 500;
					text-align: center;
					color: #999999;
					line-height: 48px;
				}

				.qd {
					width: 135px;
					height: 48px;
					line-height: 48px;
					background: rgba(255, 255, 255, 0.00);
					border-radius: 0px 0px 12px 0px;
					font-size: 17px;
					font-family: PingFang SC, PingFang SC-Medium;
					font-weight: 500;
					text-align: center;
					color: #eb413d;
				}
			}
		}
	}



}
</style>